/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S3_P1Inputs */

const en_guide_json_vs_yaml_xml_s3_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML uses indentation instead of braces, making it visually cleaner and easier to read for configuration files. It supports comments with <code>#</code>, which is essential for documenting configuration choices.`)
};

const ko_guide_json_vs_yaml_xml_s3_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML은 중괄호 대신 들여쓰기를 사용하여 설정 파일을 시각적으로 더 깔끔하고 읽기 쉽게 만듭니다. <code>#</code>으로 주석을 지원하여 설정 선택 사항을 문서화하는 데 필수적입니다.`)
};

const ja_guide_json_vs_yaml_xml_s3_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAMLは波括弧の代わりにインデントを使用するため、設定ファイルにおいて視覚的にクリーンで読みやすくなります。<code>#</code>でコメントをサポートしており、設定の選択を文書化するのに不可欠です。`)
};

/**
* | output |
* | --- |
* | "YAML uses indentation instead of braces, making it visually cleaner and easier to read for configuration files. It supports comments with <code>#</code>, whi..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s3_p1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s3_p1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s3_p1(inputs)
	return ja_guide_json_vs_yaml_xml_s3_p1(inputs)
});